// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d303483f","223":"0754cb7d","321":"dad10caa","433":"85e78449","573":"957dbcbf","830":"f5764779"}[chunkId] + ".chunk.js";
};